import regionPhotos from "./region-photos.json";

const PHOTOS = regionPhotos as Record<string, string>;

/** Local landscape photo for an ADM1 region, if seeded. */
export function getRegionPhoto(
  countrySlug?: string | null,
  regionSlug?: string | null
): string | null {
  if (!countrySlug || !regionSlug) return null;
  const key = `${countrySlug.toLowerCase()}/${regionSlug.toLowerCase().replace(/_/g, "-")}`;
  return PHOTOS[key] || null;
}
